export default "__VITE_ASSET__f6UHT9jT__"